<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "ONT List" }}</div>
        <!--按钮：重启、激活-->
        <div class="pageButton">
          <button
            type="button"
            class="btn btn-primary"
            style="
              min-width: 77px;
              color: #fff;
              background-color: #008b8b;
              border-color: #008080;
              margin-right: 10px;
            "
            @click="ontReboot()"
          >
            {{ "Reboot" }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            style="
              min-width: 77px;
              color: #fff;
              background-color: #008b8b;
              border-color: #008080;
              margin-right: 10px;
            "
            @click="ontActive()"
          >
            {{ "Active" }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            style="
              min-width: 77px;
              color: #fff;
              background-color: #008b8b;
              border-color: #008080;
              margin-right: 50px;
            "
            @click="ontDeactive()"
          >
            {{ "Deactive" }}
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current status of ont List." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <!-- ONT列表状态信息 -->
        <block-cntr :btitle="'ONT List'" style="height: 100%">
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadontlist()"
                  class="btn"
                  :class="{}"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
            <span style="margin-left: 25px; font-weight: bold"
              >Total entries: {{ total }}</span
            >

            <label style="float: right; display: flex">
              <span class="input-group-addon tablesearch-box">
                <i class="fa fa-search"></i>
              </span>
              <select
                class="form-control"
                @change="searchInfo = ''"
                v-model="searchType"
              >
                <option label="none" value=""></option>
                <option label="pon" value="pon"></option>
                <option label="ont" value="ont"></option>
                <option label="sn" value="sn"></option>
                <option label="status" value="status"></option>
              </select>
              <input
                v-if="searchType != 'status'"
                type="search"
                v-model="searchInfo"
                class="form-control"
                :placeholder="keywords"
                style="border-radius: 0px"
                :disabled="searchType == ''"
              />
              <select
                v-if="searchType == 'status'"
                class="form-control"
                style="width: 165px"
                v-model="searchInfo"
              >
                <option label="online" value="online"></option>
                <option label="offline" value="offline"></option>
              </select>
            </label>
          </div>
          <!-- ONT List 表 -->
          <table
            class="table table-hover table-noneborder-top"
            style="overflow-x: auto"
          >
            <thead style="width: 200%">
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAllOnt"
                  />
                  <label for="idSelectAllOnt"></label>
                </th>
                <th style="width: 4%">
                  {{ ontListTable.title.ontid }}
                </th>
                <th>
                  {{ ontListTable.title.sn }}
                </th>
                <th>
                  {{ ontListTable.title.devtype }}
                </th>
                <th>
                  {{ ontListTable.title.time }}
                </th>
                <th style="width: 3%">
                  {{ ontListTable.title.status }}
                </th>
                <th>
                  {{ ontListTable.title.statusInfo }}
                </th>
                <th style="width: 4%">
                  {{ ontListTable.title.ws }}
                </th>
                <th style="width: 4%">
                  {{ ontListTable.title.detail }}
                </th>
                <th style="width: 55%">
                  {{ ontListTable.title.desc }}
                </th>

                <!--<th
                  v-for="(value, key) in ontListTable.title"
                  :key="key"
                  :title="value"
                  :style="{
                    width: key === 'desc' ? '50%' : 'auto',
                  }"
                >
                  {{ value }}
                </th>-->
              </tr>
            </thead>
            <tbody style="height: 350px; width: 200%">
              <tr v-for="(row, index) in ontListFilter" :key="row.ontid">
                <td width="40px">
                  <div>
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelectOnt' + index"
                    />
                    <label :for="'idRowSelectOnt' + index"></label>
                  </div>
                </td>
                <td style="width: 4%">
                  {{ row.ontid }}
                </td>
                <td>
                  {{ row.sn }}
                </td>
                <td>
                  {{ row.devtype }}
                </td>
                <td>
                  {{ row.time }}
                </td>
                <td style="width: 3%">
                  <div
                    class="fa fa-circle"
                    :style="{
                      color: row.status === 'online' ? '#32CD32' : '#FF4500',
                    }"
                  ></div>
                </td>
                <td>
                  {{ row.statusInfo }}
                </td>
                <td style="width: 4%">
                  {{ row.ws }}
                </td>
                <td style="width: 4%">
                  <div
                    @click="ontInfoShow(row.ontid)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-external-link page-tableaction"></i>
                  </div>
                </td>
                <td style="width: 55%">
                  {{ row.desc }}
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontbrief",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      iBox: {},
      ontListTable: "",
      isSelectAll: false,
      searchType: this.$route.params.searchType ? this.$route.params.searchType : "",
      searchInfo: this.$route.params.searchInfo ? this.$route.params.searchInfo : "",
      total: "",
      keywords: "",
    }
  },
  created() {
    this.loadontlist()
  },
  methods: {
    loadontlist() {
      get("ontBrief")
        .then((res) => {
          this.ontListTable = res.data
          this.total = res.data.count
        })
        .catch((err) => {
          this.ontListTable = en.ontListTable
        })
    },
    ontReboot() {
      var configData = {
        ontList: [],
      }
      for (let i = 0; i < this.ontListTable.data.length; i++) {
        if (this.ontListTable.data[i].selected == true) {
          configData.ontList.push({ ont: this.ontListTable.data[i].ontid })
        }
      }
      if (configData.ontList.length == 0) {
        return
      }
      if (configData.ontList.length > 100) {
        this.showAlertBox(
          "warn",
          "Message",
          "Select ONT number is larger than 100"
        )
        return
      }

      post("ontReboot", configData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          )
            this.showAlertBox("info", "Info", res.data.msg)
          else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      return
    },
    ontActive() {
      var configData = {
        ontList: [],
      }
      for (let i = 0; i < this.ontListTable.data.length; i++) {
        if (this.ontListTable.data[i].selected == true) {
          configData.ontList.push({ ont: this.ontListTable.data[i].ontid })
        }
      }
      if (configData.ontList.length == 0) {
        return
      }
      if (configData.ontList.length > 100) {
        this.showAlertBox(
          "warn",
          "Message",
          "Select ONT number is larger than 100"
        )
        return
      }

      post("ontActive", configData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          )
            this.showAlertBox("info", "Info", res.data.msg)
          else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    ontDeactive() {
      var configData = {
        ontList: [],
      }
      for (let i = 0; i < this.ontListTable.data.length; i++) {
        if (this.ontListTable.data[i].selected == true) {
          configData.ontList.push({ ont: this.ontListTable.data[i].ontid })
        }
      }
      if (configData.ontList.length == 0) {
        return
      }

      if (configData.ontList.length > 100) {
        this.showAlertBox(
          "warn",
          "Message",
          "Select ONT number is larger than 100"
        )
        return
      }

      post("ontDeactive", configData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            setTimeout(this.loadontlist, 1000)
            this.showAlertBox("info", "Info", res.data.msg)
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    changeSelectAll() {
      for (let i = 0; i < this.ontListFilter.length; i++) {
        if (this.isSelectAll) {
          this.ontListFilter[i].selected = true
        } else {
          this.ontListFilter[i].selected = false
        }
      }
    },

    selectNull() {
      for (let i = 0; i < this.ontListTable.data.length; i++) {
        this.ontListTable.data[i].selected = false
      }
      this.isSelectAll = false
    },
    /* 行有效打印 */
    printableRow(row) {
      var prow = {}
      for (var c in row) {
        if (c === "selected") {
          continue
        }
        prow[c] = row[c]
      }
      return prow
    },
    ontInfoShow(ontId) {
      this.$router.push({
        path: "/ontInfo",
        name: "ontInfo",
        query: { ontIndex: ontId },
      })
    },
    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
  watch: {
    searchType: function (newValue, oldValue) {
      if (newValue == "pon") {
        this.keywords = "slot/pon"
      } else if (newValue == "ont") {
        this.keywords = "slot/pon/ont"
      } else if (newValue == "sn") {
        this.keywords = "SN"
      } else {
        this.keywords = ""
      }
    },
  },
  computed: {
    ontListFilter() {
      var ontTable = []
      var number = 0
      if (this.ontListTable.data !== undefined)
        this.ontListTable.data.forEach((element) => {
          if (
            this.searchInfo == "" ||
            (this.searchType == "pon" &&
              element["ontid"].split("/")[0] == this.searchInfo.split("/")[0] &&
              element["ontid"].split("/")[1] ==
                this.searchInfo.split("/")[1]) ||
            (this.searchType == "ont" && this.searchInfo == element["ontid"]) ||
            (this.searchType == "sn" &&
              element["sn"].indexOf(this.searchInfo) !== -1) ||
            (this.searchType == "status" &&
              this.searchInfo == element["status"])
          ) {
            ontTable.push(element)
            number += 1
          }
        })
      this.total = number
      return ontTable
    },
  },
}
</script>